export enum RoutesEnum {
    Pay = '/pay/:id',
    Success = '/success/:id',
    Error = '/error/:id',
    TestRoot = '/',
}
